import { View } from 'dripsy';
import * as React from 'react';
import { TooltipArrow } from './TooltipArrow';
export const TooltipArrowDown = React.forwardRef(({ left }, forwardedRef) => (React.createElement(View, { ref: forwardedRef, accessibilityHidden: true, sx: {
        position: 'absolute',
        bottom: -2,
        left: left ? `${left}px` : '50%',
        transform: 'translateX(-50%) scaleY(-1)',
    } },
    React.createElement(TooltipArrow, null))));
//# sourceMappingURL=TooltipArrowDown.js.map